/* GodHund juleforside 2026 – Claude 12.10.2026. Ingen bibliotek. */
(function () {
  'use strict';
  var D = document, W = window, R = D.getElementById('gj');
  if (!R) return;
  W.__gjul = 1;
  R.classList.add('gj-js'); R.classList.remove('gj-nojs');
  var $ = function (s, c) { return (c || R).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || R).querySelectorAll(s)); };
  var calm = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IO = 'IntersectionObserver' in W;
  var CFG = {}; try { CFG = JSON.parse(($('#gj-cfg') || {}).textContent || '{}'); } catch (e) {}

  /* nedtelling til julaften (Oslo-tid) */
  var cnt = $('[data-count]');
  if (cnt) {
    try {
      var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Oslo', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()).split('-');
      var d = Math.round((Date.UTC(+p[0], 11, 24) - Date.UTC(+p[0], +p[1] - 1, +p[2])) / 864e5);
      var n = $('[data-count-n]', cnt), t = $('[data-count-t]', cnt);
      if (d === 0) { n.textContent = '★'; t.textContent = CFG.eve || ''; cnt.hidden = false; }
      else if (d > 0 && d <= 100) { n.textContent = d; t.textContent = d === 1 ? CFG.d1 : CFG.dn; cnt.hidden = false; }
    } catch (e) {}
  }

  /* snø (canvas), pauser når den ikke synes */
  function snow(cv, max) {
    if (!cv || !cv.getContext || calm) return;
    var ctx = cv.getContext('2d'), fl = [], w = 0, h = 0, dpr = Math.min(W.devicePixelRatio || 1, 1.5), on = false, raf = 0, last = 0;
    var mob = W.matchMedia('(max-width: 749px)').matches, step = mob ? 33 : 16;
    function mk(any) { var z = Math.random(); return { x: Math.random() * w, y: any ? Math.random() * h : -8, r: .7 + z * 2.3, s: .22 + z * .85, a: .35 + z * .55, ph: Math.random() * 6.28, sw: .3 + Math.random() * .7 }; }
    function size() {
      var r = cv.getBoundingClientRect(); w = r.width; h = r.height; if (!w || !h) return;
      cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var want = Math.round(Math.min(mob ? max * .5 : max, w * h / 9000));
      while (fl.length < want) fl.push(mk(true)); fl.length = want;
    }
    function draw(ts) {
      raf = 0; if (!on || D.hidden) return;
      if (ts - last >= step) {
        var dt = Math.min(3, (ts - last) / 16.7); last = ts;
        ctx.clearRect(0, 0, w, h); ctx.fillStyle = '#fff';
        for (var i = 0; i < fl.length; i++) {
          var f = fl[i]; f.y += f.s * dt; f.ph += .012 * dt; f.x += Math.sin(f.ph) * f.sw * .5 * dt;
          if (f.y > h + 6) { fl[i] = mk(false); continue; }
          ctx.globalAlpha = f.a; ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 6.283); ctx.fill();
        }
      }
      raf = requestAnimationFrame(draw);
    }
    function go() { if (!raf && on && !D.hidden) raf = requestAnimationFrame(draw); }
    var start = function () { size(); if (IO) new IntersectionObserver(function (en) { on = en[0].isIntersecting; go(); }, { threshold: 0 }).observe(cv); else { on = true; go(); } };
    if ('requestIdleCallback' in W) requestIdleCallback(start, { timeout: 1500 }); else setTimeout(start, 600);
    var rt; W.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { mob = W.matchMedia('(max-width: 749px)').matches; step = mob ? 33 : 16; size(); }, 200); }, { passive: true });
    D.addEventListener('visibilitychange', go);
  }
  snow($('[data-hero] [data-snow]'), 140);

  /* inngang ved scroll + gaver som pakkes opp */
  var rv = $$('.gj-rv');
  function openGift(c) { if (!c.classList.contains('is-open')) setTimeout(function () { c.classList.add('is-open'); }, 150); }
  var ro = null;
  if (IO && !calm) {
    ro = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return; var t = e.target; ro.unobserve(t);
        if (t.classList.contains('gj-gift')) openGift(t); else t.classList.add('is-in');
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: .12 });
    rv.forEach(function (e) { ro.observe(e); });
    $$('.gj-pan.is-on .gj-gift').forEach(function (c) { ro.observe(c); });
  } else { rv.forEach(function (e) { e.classList.add('is-in'); }); $$('.gj-gift').forEach(function (c) { c.classList.add('is-open'); }); }

  /* gaveguide-faner */
  var tabs = $$('[data-tab]');
  function sel(k, focus) {
    tabs.forEach(function (b) { var on = b.getAttribute('data-tab') === k; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; if (on && focus) b.focus(); });
    $$('[data-pan]').forEach(function (p) {
      var on = p.getAttribute('data-pan') === k; p.classList.toggle('is-on', on);
      if (on) { var r = $('[data-rail]', p); if (r) r.scrollLeft = 0; $$('.gj-gift', p).forEach(function (c) { if (ro) ro.observe(c); else c.classList.add('is-open'); }); }
    });
  }
  tabs.forEach(function (b, i) {
    b.addEventListener('click', function () { sel(b.getAttribute('data-tab')); if (b.scrollIntoView) b.scrollIntoView({ block: 'nearest', inline: 'center', behavior: calm ? 'auto' : 'smooth' }); });
    b.addEventListener('keydown', function (e) { var m = { ArrowRight: 1, ArrowLeft: -1 }[e.key]; if (!m) return; e.preventDefault(); var n = tabs[(i + m + tabs.length) % tabs.length]; sel(n.getAttribute('data-tab'), true); });
  });

  /* myk rulling til ankere på siden */
  $$('a[href^="#gj-"]').forEach(function (a) {
    a.addEventListener('click', function (e) { var t = D.getElementById(a.getAttribute('href').slice(1)); if (!t) return; e.preventDefault(); W.scrollTo({ top: t.getBoundingClientRect().top + W.scrollY - 70, behavior: calm ? 'auto' : 'smooth' }); });
  });

  /* hurtigkjøp + oppdater handlekurv-ikonet i headeren */
  var toast = $('[data-toast]'), tt;
  function showToast(msg, ok) {
    if (!toast) return; $('[data-toast-t]', toast).textContent = msg; $('a', toast).hidden = !ok;
    toast.hidden = false; toast.style.animation = 'none'; void toast.offsetWidth; toast.style.animation = '';
    clearTimeout(tt); tt = setTimeout(function () { toast.hidden = true; }, 4200);
  }
  function bubble() {
    var el = D.getElementById('cart-icon-bubble'); if (!el) return Promise.resolve();
    return fetch((CFG.root || '/') + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (j) {
      var html = j && j['cart-icon-bubble']; if (!html) return;
      var tmp = D.createElement('div'); tmp.innerHTML = html;
      var nw = tmp.querySelector('#cart-icon-bubble') || tmp.querySelector('.shopify-section');
      if (nw) el.innerHTML = nw.innerHTML;
    }).catch(function () {});
  }
  R.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[data-add]'); if (!b || b.disabled) return;
    e.preventDefault(); b.disabled = true;
    fetch(CFG.cartAdd || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-add'), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw 0; return bubble(); })
      .then(function () { b.classList.add('is-ok'); showToast(CFG.added, true); setTimeout(function () { b.classList.remove('is-ok'); }, 1600); try { D.dispatchEvent(new CustomEvent('cart:refresh')); } catch (x) {} })
      .catch(function () { showToast(CFG.err, false); })
      .then(function () { b.disabled = false; });
  });
})();
